import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserProvider } from '../user/user';
import { environment } from '../../environments/environment';

@Injectable()
export class SoreiSaishiProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(
    public http: HttpClient,
    public userProvider: UserProvider,
  ) {}

  getPeriodoNensai(id, idEspirito) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa-linhagem-espirito-api/periodo-nensai', { id, idEspirito })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getSolicitacaoIreisai(id) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa-linhagem-espirito-api/solicitacao-ireisai', { id })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getSolicitacaoCulto(id, data) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa-linhagem-espirito-api/solicitacao-culto', { id, data })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getBuscaPrece(pag) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa-linhagem-espirito-api/get-busca-prece', {
        observe: 'response',
        params: {
          expand: 'total',
          page: pag.currentPage,
          'per-page': '10',
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };

        return {
          prece: data.body,
          pagination: pag,
        };
      });
  }

  getBuscaCampos() {
    return this.http.post<any>(this.baseUrl + '/pessoa-linhagem-espirito-api/busca-campos', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  savePedidoPrece(dados) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa-linhagem-espirito-api/save-pedido-prece', { dados: dados })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  removerPrece(id) {
    return this.http.delete<any>(this.baseUrl + '/pessoa-linhagem-espirito-api/remover-prece/' + id).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/sorei-saishi/sorei-saishi.ts